<script lang="ts" setup></script>

<template>
  <div class="border-D-e border-D-b relative hidden max-w-[35vw] flex-1 border-white text-center p-D-29 md:flex">
    <!-- <div class="absolute right-0 bg-black bottom-D--5 h-D-10 w-D-50"></div>
    <div class="absolute top-0 bg-black right-D--5 w-D-10 h-D-50"></div> -->
    <p class="font-bebas-neue m-auto text-D-52 leading-D-62">
      {{ $t("home.vision_blog.stay_turned_for__") }}
    </p>
  </div>

  <div class="flex md:hidden">
    <div class="border-M-e border-white w-M-23"></div>
    <div class="border-M-e border-M-b flex-1 border-white p-M-7">
      <p class="font-bebas-neue text-M-42 leading-M-50 mb-M-70 mt-M-70">
        {{ $t("home.vision_blog.stay_turned_for__") }}
      </p>
    </div>
    <div class="w-M-24"></div>
  </div>
</template>
